function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { openModal } from "@common/actions/index";
import PrismicClient from "@common/utils/prismic";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { isEmpty } from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { COOKIE_POLICY, FREQUENTLY_ASKED_QUESTIONS, INSTALLATION_GUIDE, PRIVACY_POLICY, TERMS_AND_CONDITIONS } from "@config/constants";
var AuthenticationFooterMenu = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(AuthenticationFooterMenu, Component);
    var _super = _create_super(AuthenticationFooterMenu);
    function AuthenticationFooterMenu(props) {
        _class_call_check(this, AuthenticationFooterMenu);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            anchorEl: null,
            open: false,
            hasGuide: false
        };
        _this.handleClose = _this.handleClose.bind(_assert_this_initialized(_this));
        _this.menuRef = null;
        _this.handleClick = _this.handleClick.bind(_assert_this_initialized(_this));
        _this.openModal = _this.openModal.bind(_assert_this_initialized(_this));
        _this.handleClickOutside = _this.handleClickOutside.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(AuthenticationFooterMenu, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var prismicData;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                document.addEventListener("mousedown", _this.handleClickOutside);
                                if (!PrismicClient.hasPrismic()) return [
                                    2
                                ];
                                return [
                                    4,
                                    PrismicClient.getAppGuide()
                                ];
                            case 1:
                                prismicData = _state.sent();
                                if (!isEmpty(prismicData)) {
                                    _this.setState({
                                        hasGuide: true
                                    });
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("mousedown", this.handleClickOutside);
            }
        },
        {
            // here we are checking if the videoPlayer isOpen state is being toggled
            // and we are closing the help menu if true
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                if (nextProps.videoPlayer.isOpen !== this.state.isVideoPlayerOpened) {
                    this.setState({
                        anchorEl: null,
                        isVideoPlayerOpened: nextProps.videoPlayer.isOpen
                    });
                }
            }
        },
        {
            /**
     *  Handles click outside of  menu and calls
     *  handleClose method if click is outside help menu
     *  @param {Object} event
     */ key: "handleClickOutside",
            value: function handleClickOutside(event) {
                if (this.menuRef && !this.menuRef.contains(event.target)) {
                    this.handleClose();
                }
            }
        },
        {
            /**
     *  Open menu and close it on MenuItem click
     *  @param {Object} event
     */ key: "handleClick",
            value: function handleClick(event) {
                event.stopPropagation();
                var eventTarget = event.currentTarget;
                this.state.anchorEl ? this.handleClose() : this.setState({
                    anchorEl: eventTarget
                });
            }
        },
        {
            /**
     *  Closes the menu
     */ key: "handleClose",
            value: function handleClose() {
                this.setState({
                    anchorEl: null
                });
            }
        },
        {
            /**
     *  Opens the modal
     *  @param event {Object}
     *  @param modalName {String}
     *  @param modalProps {Object}
     */ key: "openModal",
            value: function openModal(event, modalName, modalProps) {
                event.stopPropagation();
                this.props.openModal(modalName, modalProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var i18n = this.props.i18n;
                var anchorEl = this.state.anchorEl;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "menu-button",
                    ref: function(node) {
                        return _this.menuRef = node;
                    },
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "icon icon-menu pointer",
                            "aria-owns": anchorEl ? "authentication-footer-menu" : null,
                            "aria-haspopup": "true",
                            onClick: this.handleClick
                        }),
                        /*#__PURE__*/ _jsxs(Menu, {
                            className: "menu authentication-footer-menu",
                            PaperProps: {
                                className: "authentication-menu-paper",
                                style: {
                                    maxHeight: "none",
                                    transform: "cubic-bezier(1, 0.32, 1, 0.31)"
                                }
                            },
                            anchorEl: anchorEl,
                            open: Boolean(anchorEl),
                            onClose: this.handleClose,
                            children: [
                                /*#__PURE__*/ _jsx(MenuItem, {
                                    className: "menu-item",
                                    onClick: function(event) {
                                        return _this.openModal(event, FREQUENTLY_ASKED_QUESTIONS);
                                    },
                                    children: i18n.common.help
                                }),
                                /*#__PURE__*/ _jsx(MenuItem, {
                                    className: "menu-item",
                                    onClick: function(event) {
                                        return _this.openModal(event, TERMS_AND_CONDITIONS, {
                                            title: i18n.termsAndConditions.title,
                                            text: i18n.termsAndConditions.text
                                        });
                                    },
                                    children: i18n.account.terms
                                }),
                                /*#__PURE__*/ _jsx(MenuItem, {
                                    className: "menu-item",
                                    onClick: function(event) {
                                        return _this.openModal(event, PRIVACY_POLICY, {
                                            title: i18n.privacyPolicy.title,
                                            text: i18n.privacyPolicy.text
                                        });
                                    },
                                    children: i18n.privacyPolicy.title
                                }),
                                /*#__PURE__*/ _jsx(MenuItem, {
                                    className: "menu-item",
                                    onClick: function(event) {
                                        return _this.openModal(event, COOKIE_POLICY, {
                                            title: i18n.cookiePolicy.title,
                                            text: i18n.cookiePolicy.text
                                        });
                                    },
                                    children: i18n.cookiePolicy.title
                                }),
                                this.state.hasGuide && /*#__PURE__*/ _jsx(MenuItem, {
                                    className: "menu-item",
                                    onClick: function(event) {
                                        return _this.openModal(event, INSTALLATION_GUIDE, {
                                            setPostLoginModalOpened: function() {
                                                return null;
                                            },
                                            isModal: true
                                        });
                                    },
                                    children: i18n.common.apps
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return AuthenticationFooterMenu;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, videoPlayer = param.videoPlayer, screenType = param.screenType;
    return {
        i18n: i18n,
        videoPlayer: videoPlayer,
        screenType: screenType
    };
};
export default connect(mapStateToProps, {
    openModal: openModal
})(AuthenticationFooterMenu);
